import { useQuery } from "@tanstack/react-query";
import { milestoneKeys } from "components/milestone/queries";
import { calculateTotalHours } from "utils/utils";
import { fetchTimesheetSpentHoursForMilestone } from "../spent/api";

export function useMilestoneLoggedHours(id, dateRange) {
  return useQuery({
    queryFn: () => fetchTimesheetSpentHoursForMilestone({ id, dateRange }),
    queryKey: milestoneKeys.allLoggedHours(id, dateRange),
    select: (data) => calculateTotalHours(data, "logged_hours"),
    enabled: !!id,
  });
}
